module.exports = __webpack_public_path__ + "static/flags/MP-0ce73173024679c13f824f4e79359ddd.gif";